import { Box, Typography, Button, Container, Paper, EmailOutlinedIcon, HomeOutlinedIcon } from 'src/components';
import { useNavigate } from 'react-router-dom';

function DeleteAccount() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 3,
            width: '100%',
            maxWidth: 400,
          }}
        >
          {/* Title */}
          <Typography
            variant="h3"
            sx={{
              fontWeight: 'bold',
              color: 'warning.main',
              mb: 1,
            }}
          >
            Delete Account
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, lineHeight: 1.6 }}
          >
            To delete your account and all associated data, please contact our support team by emailing:
          </Typography>

          {/* Email contact */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 4,
              gap: 1,
              fontWeight: 600,
              fontSize: '1.1rem',
              color: 'text.primary',
            }}
          >
            <EmailOutlinedIcon fontSize="medium" />
            <Typography component="span">panamexplorer@gmail.com</Typography>
          </Box>

          {/* Action button */}
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="outlined"
              startIcon={<HomeOutlinedIcon />}
              onClick={handleGoHome}
              size="large"
              sx={{ minWidth: 120 }}
            >
              Go Home
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default DeleteAccount;
